
import { Navigate } from 'react-router-dom';

export default function IndependentCaregiversDirectory() {
  // Legacy route redirect to the unified caregivers directory
  return <Navigate to="/caregivers/directory" replace />;
}
